import dayjs from 'dayjs';
import { dateWithoutTimezone } from 'common/helpers/dateWithoutTimezone';

/**
 * Converts a Date object to a specified time zone.
 *
 * @param date - The Date object to convert.
 * @param tz - The time zone to convert the Date object to.
 * @returns A string representation of the Date object in ISO format, converted to the specified time zone.
 */
export const convertDateToTimeZone = (date: Date, tz: string) => {
  return dayjs.tz(dateWithoutTimezone(new Date(date)), tz).toISOString();
};
